<template>
    <div>
     <v-container fluid>
    <v-row align="center">
        <v-select
          :items="this.$store.state.cities"
          label="City"
          @change="fetchApiData_otherRestaurants()"
          v-model="CITY"
        ></v-select>
    </v-row>
      <v-row align="center">
        <v-col
            cols="8"
            sm="10"
        >
        </v-col>
        <v-col
            cols="2"
            sm="1"
          >
            <AddNewData
            v-bind:ITEM="ITEM"
        ></AddNewData>
          </v-col>
          <v-col
            cols="2"
            sm="1"
          >
            <v-btn
              icon
              color="green"
              large
              @click="fetchApiData_otherRestaurants()"
            >
              <v-icon>mdi-cached</v-icon>
            </v-btn>
          </v-col>


      </v-row>
    </v-container>
    <v-data-table
        dense
        hide-default-footer
        disable-pagination
        fixed-header
        height="600px"
        :sort-by="['RESTAURANT']"
        :sort-desc="[false]"
        :headers="headers" 
        :items="OTHER_RESTAURANTS"
        :mobile-breakpoint='100'
    >
     
      <!-- URL_LINK -->
      <template v-slot:item.URL_LINK="props">
        <v-edit-dialog
          :return-value.sync="props.item.URL_LINK"
          large
          @save="save(props.item)"
          @cancel="cancel"
          @open="open"
          @close="close"
        >
          {{ props.item.URL_LINK }}
          <template v-slot:input>
            <v-text-field
              v-model="props.item.URL_LINK"
              label="Edit"
              single-line
              counter
            ></v-text-field>
          </template>
        </v-edit-dialog>
      </template>


      <!-- GENRE -->
      <template v-slot:item.GENRE="props">
        <v-edit-dialog
          :return-value.sync="props.item.GENRE"
          large
          @save="save(props.item)"
          @cancel="cancel"
          @open="open"
          @close="close"
        >
          {{ props.item.GENRE }}
          <template v-slot:input>
            <v-text-field
              v-model="props.item.GENRE"
              label="Edit"
              single-line
              counter
            ></v-text-field>
          </template>
        </v-edit-dialog>
      </template>

      <!-- Actions -->
      <template v-slot:item.actions="{ item }">
        <v-row justify="space-around">
          <v-icon
          @click="duplicateItem(item)"
        >
          mdi-content-copy
        </v-icon>
        
        <v-icon
          @click="deleteItem(item)"
          color="red darken-2"
        >
          mdi-delete
        </v-icon>
      
      </v-row>

      <v-dialog v-model="dialogDelete" max-width="500px" :retain-focus="false">
          <v-card>
            <v-card-title class="text-h5">Are you sure you want to delete this item?</v-card-title>
            <v-card-text>Restaurant: {{ITEM.RESTAURANT}}, CITY:{{ITEM.CITY}}</v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
              <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
   
    </v-data-table>
  </div>
</template>


<script>
import AddNewData from "./infoOtherRestaurantsAddNewData";

export default {
    name: 'AutoConfigTables',
    components: { AddNewData },
    data() {
        return {
            dialogDelete: false,
            dialogTest: false,
            snack: false,
            snackColor: '',
            snackText: '',
            max80chars: v => v.length <= 80 || 'Input too long!',
            RAW_OUTPUT: '',
           headers: [
                { text: 'Actions', value: 'actions', sortable: false },
                {
                    text: 'CITY',
                    align: 'start',
                    style: "bold",
                    value: 'CITY'
                },
                { text: 'RESTAURANT', value: 'RESTAURANT' },
                { text: 'GENRE', value: 'GENRE' },
                { text: 'URL_LINK', value: 'URL_LINK' },
            ],
            OTHER_RESTAURANTS: [],
            CITY: '',
            ITEM: {
              CITY: '',
              RESTAURANT: '',
              GENRE: '',
              URL_LINK: ''
            }
        }
    },
    methods: {
        save (item) {
          console.log("SAVE:", item);
          this.postApiData(item);
          this.snack = true;
          this.snackColor = 'success';
          this.snackText = 'Data saved';
        },
        cancel () {
            this.snack = true;
            this.snackColor = 'error';
            this.snackText = 'Canceled';
        },
        open () {
            this.snack = true;
            this.snackColor = 'info';
            this.snackText = 'Dialog opened';
        },
        close () {
            console.log('Dialog closed');
        },
        closeDialog () {
            console.log('Dialog closed');
            this.dialog = false;
        },
        closeTest () {
          console.log('Dialog closed');
          this.dialogTest = false;
          this.RAW_OUTPUT = '';
        },
        duplicateItem(item) {
          console.log("Duplicating item.");
          this.ITEM = item;
        },
        deleteItem (item) {
          console.log("ITEM:", item);
          this.ITEM = item;
          this.dialogDelete = true;
        },
        deleteItemConfirm () {
          var city, restaurant;
          city = this.ITEM.CITY;
          restaurant = this.ITEM.RESTAURANT;
          this.deleteOtherRestaurantItem(city, restaurant);
          this.closeDelete();
          this.ITEM = "";
          this.fetchApiData_otherRestaurants();
        },
        closeDelete () {
          this.dialogDelete = false;
        },
        city (value) {
          this.CITY = value;
        },
        postApiData(item){
            var response, url;
            url = this.$store.state.api_url + "info/restaurants/others";
            console.log(url);
            fetch(url, {
              "method": "POST",
              "mode": "cors",
              "headers": {
                'Content-Type': 'application/json',
                'Authorization': this.$store.state.token
              },
              "body": JSON.stringify(item)
            })
            .then(response => response.json()) 
            .then(data => { 
                if(data){
                    console.log(data);
                } else{
                    alert("Server returned " + response.status + " : " + response.statusText);
                }                
            })
            .catch(err => {
                console.log(err);
            });          
        },
        deleteOtherRestaurantItem(city, restaurant) {
          console.log("Deleting item using API");
          var response, url;
          var r = restaurant.replace("&", "%26");
          url = this.$store.state.api_url + "info/restaurants/others?city=" + city + "&restaurant=" + r;
          console.log(url);
          fetch(url, {
              "method": "DELETE",
              "mode": "cors",
              "headers": {
                  'Content-Type': 'application/json',
                  'Authorization': this.$store.state.token
              }
          })
          .then(response => response.json()) 
          .then(data => { 
              if(data){
                  console.log(data);
              } else{
                  alert("Server returned " + response.status + " : " + response.statusText);
              }                
          })
          .catch(err => {
              console.log(err);
          });
        },
        fetchApiData_cities() {
            console.log("Fetching data");
            var response, url;
            url = this.$store.state.api_url + "info/cities";
            console.log(url);
            fetch(url, {
                "method": "GET",
                "mode": "cors",
                "headers": {
                    'Content-Type': 'application/json',
                    'Authorization': this.$store.state.token
                }
            })
            .then(response => response.json()) 
            .then(data => { 
                if(data){
                    console.log(data);
                    var city_list = [];
                    for (var i in data) {
                      city_list.push(data[i]["CITY"]);
                    }
                    this.$store.state.cities = city_list;
                } else{
                    alert("Server returned " + response.status + " : " + response.statusText);
                }                
            })
            .catch(err => {
                console.log(err);
            });
        },
        fetchApiData_otherRestaurants() {
            var city = this.CITY;
            this.OTHER_RESTAURANTS = [];
            console.log("CITY:", city);
            var response, url;
            url = this.$store.state.api_url + "info/restaurants/others?city=" + city;
            console.log(url);
            fetch(url, {
                "method": "GET",
                "mode": "cors",
                "headers": {
                    'Content-Type': 'application/json',
                    'Authorization': this.$store.state.token
                }
            })
            .then(response => response.json()) 
            .then(data => { 
                if(data){
                    console.log(data);
                    for (var i in data) {
                      this.OTHER_RESTAURANTS.push(data[i]);
                    }
                } else{
                    alert("Server returned " + response.status + " : " + response.statusText);
                }                
            })
            .catch(err => {
                console.log(err);
            });
        }
    },
    mounted() {
        this.fetchApiData_cities();
    },
    watch: {
      dialogDelete (val) {
        val || this.closeDelete()
      },
    },
}
</script>



<style scoped>
p{
    font-size: 10px;
}
a {
    color: #0067a7 !important;
    text-decoration: none;
    font-size: 16px;
}
a:hover {
    color: #0c0c0c;
    text-decoration: underline;
}

.lunch-table-header {
    text-align: center;
    background-color: #e6e6e6;
}

thead {
    border-bottom-width: 2px;
    vertical-align: bottom;
    border-bottom: 2px solid #e9ecef;
    border: 1px solid #e9ecef;
    padding: 4px;
}

th {
    border-bottom-width: 2px;
    vertical-align: top;
    border-bottom: 2px solid #e9ecef;
    border: 1px solid #e9ecef;
    padding: 4px;
}


td {
    border: 1px solid #e9ecef;
    padding-left: 10px;
}


table {
    width: 100%;
    max-width: 100%;
    margin-bottom: 0.01rem;
    background-color: transparent;
    border-collapse: collapse;
    border: 1px solid #e9ecef;
    display: table;
    white-space: normal;
    line-height: normal;
    font-weight: normal;
    font-size: medium;
    font-style: normal;
    color: -internal-quirk-inherit;
    text-align: start;
    border-spacing: 2px;
    font-variant: normal;
}

.w-66 {
    width: 66% !important;
}
.w-33 {
    width: 33% !important;
}


</style>